// Users allowed to edit Bowler data (targets & manual actuals).
// Add lowercase email addresses here, one per entry.
// If the list is empty, editing is disabled for everyone.
// Set REACT_APP_BOWLER_EDIT_USERS="a@x.com,b@x.com" at build time to override.
const _envList =
  process.env.REACT_APP_BOWLER_EDIT_USERS
    ? process.env.REACT_APP_BOWLER_EDIT_USERS.split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
    : [];

const BOWLER_EDIT_USERS: string[] = _envList.length > 0 ? _envList : [
  'mahesh.s.bhosale@maersk.com',
  'nilesh.chakkar@maersk.com',
  'm.h.javed@maersk.com',
  'vaishali.parande@maersk.com',
];

export default BOWLER_EDIT_USERS;
